// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as Window$OrcaPaymentPage from "./Window.bs.js";
import * as S3Utils$OrcaPaymentPage from "./Utilities/S3Utils.bs.js";
import * as CardTheme$OrcaPaymentPage from "./CardTheme.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "./Utilities/ApiEndpoint.bs.js";
import * as CommonHooks$OrcaPaymentPage from "./Hooks/CommonHooks.bs.js";
import * as ElementType$OrcaPaymentPage from "./Types/ElementType.bs.js";
import * as PaymentType$OrcaPaymentPage from "./Types/PaymentType.bs.js";
import * as DefaultTheme$OrcaPaymentPage from "./DefaultTheme.bs.js";
import * as JotaiAtomsV2$OrcaPaymentPage from "./Utilities/JotaiAtomsV2.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "./Hooks/UtilityHooks.bs.js";
import * as CardThemeType$OrcaPaymentPage from "./Types/CardThemeType.bs.js";
import * as SdkConfigParser$OrcaPaymentPage from "../shared-code/sdk-utils/utils/SdkConfigParser.bs.js";
import * as UnifiedHelpersV2$OrcaPaymentPage from "./Utilities/UnifiedHelpersV2.bs.js";
import * as UpdateIntentOverlay$OrcaPaymentPage from "./Components/UpdateIntentOverlay.bs.js";
import * as SubscriptionEventTypes$OrcaPaymentPage from "./Types/SubscriptionEventTypes.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./Utilities/PaymentMethodCollectUtils.bs.js";

function LoaderController(props) {
  let initTimestamp = props.initTimestamp;
  let logger = props.logger;
  let setIntegrateErrorError = props.setIntegrateErrorError;
  let paymentMode = props.paymentMode;
  let match = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.configAtom);
  let setConfig = match[1];
  let setIsConfigReady = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isConfigReady);
  let match$1 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.keys);
  let setKeys = match$1[1];
  let keys = match$1[0];
  let match$2 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.paymentMethodList);
  let setPaymentMethodList = match$2[1];
  let paymentMethodList = match$2[0];
  let setSdkConfigs = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.sdkConfigs);
  let setSdkConfigsValue = Jotai.useSetAtom(PaymentUtils$OrcaPaymentPage.sdkConfigsValue);
  let setSessions = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.sessions);
  let match$3 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.elementOptions);
  let setOptions = match$3[1];
  let options = match$3[0];
  let match$4 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.optionAtom);
  let setOptionsPayment = match$4[1];
  let optionsPayment = match$4[0];
  let setPaymentManagementList = Jotai.useSetAtom(JotaiAtomsV2$OrcaPaymentPage.paymentManagementList);
  let setSessionId = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.sessionId);
  let setBlockConfirm = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isConfirmBlocked);
  let setCustomPodUri = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.customPodUri);
  let setIsGooglePayReady = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isGooglePayReady);
  let setTrustPayScriptStatus = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.trustPayScriptStatus);
  let setIsApplePayReady = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isApplePayReady);
  let setIsSamsungPayReady = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isSamsungPayReady);
  let setUpdateSession = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.updateSession);
  let setIsUpdateIntentLoading = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isUpdateIntentLoading);
  let match$5 = React.useState(() => 0.0);
  let setDivH = match$5[1];
  let divH = match$5[0];
  let match$6 = React.useState(() => 0.0);
  let paymentMethodOrder = optionsPayment.paymentMethodOrder;
  let setLaunchTime = match$6[1];
  let launchTime = match$6[0];
  let setPaymentMethodCollectOptions = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.paymentMethodCollectOptionAtom);
  let url = RescriptReactRouter.useUrl(undefined, undefined);
  let componentName = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName");
  let divRef = React.useRef(null);
  let iframeId = keys.iframeId;
  let config = match[0].config;
  let messageParentWindow = data => Utils$OrcaPaymentPage.messageParentWindow(keys.parentURL, data);
  let setUserFullName = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.userFullName);
  let setUserEmail = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.userEmailAddress);
  let setUserAddressline1 = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.userAddressline1);
  let setUserAddressline2 = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.userAddressline2);
  let setUserAddressCity = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.userAddressCity);
  let setUserAddressPincode = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.userAddressPincode);
  let setUserAddressState = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.userAddressState);
  let setUserAddressCountry = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.userAddressCountry);
  let setCountry = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.userCountry);
  let setIsCompleteCallbackUsed = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  let setIsPaymentButtonHandlerProvided = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isPaymentButtonHandlerProvidedAtom);
  let setIsTestMode = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isTestMode);
  let setIsSavedCardCvcFlow = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isSavedCardCvcFlow);
  let setCardCollectionMode = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.cardCollectionMode);
  let setCardBrand = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.cardBrand);
  let setSupportedCardBrands = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.supportedCardBrands);
  let setSavedCardBrand = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.savedCardBrand);
  let setIsBancontactCardFlow = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isBancontactCardFlow);
  let setCardFlowType = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.cardFlowType);
  let updateOptions = dict => {
    let optionsDict = Utils$OrcaPaymentPage.getDictFromObj(dict, "options");
    let match = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
    switch (match) {
      case "Card" :
      case "CardNumberElement" :
      case "CardExpiryElement" :
      case "CardCVCElement" :
        break;
      case "PaymentMethodCollectElement" :
        let paymentMethodCollectOptions = PaymentMethodCollectUtils$OrcaPaymentPage.itemToObjMapper(optionsDict);
        return setPaymentMethodCollectOptions(param => paymentMethodCollectOptions);
      case "NONE" :
        return;
      default:
        let paymentOptions = PaymentType$OrcaPaymentPage.itemToObjMapper(optionsDict, logger);
        setOptionsPayment(param => paymentOptions);
        [
          [
            paymentOptions.defaultValues.billingDetails.name,
            setUserFullName
          ],
          [
            paymentOptions.defaultValues.billingDetails.email,
            setUserEmail
          ],
          [
            paymentOptions.defaultValues.billingDetails.address.line1,
            setUserAddressline1
          ],
          [
            paymentOptions.defaultValues.billingDetails.address.line2,
            setUserAddressline2
          ],
          [
            paymentOptions.defaultValues.billingDetails.address.city,
            setUserAddressCity
          ],
          [
            paymentOptions.defaultValues.billingDetails.address.postal_code,
            setUserAddressPincode
          ],
          [
            paymentOptions.defaultValues.billingDetails.address.state,
            setUserAddressState
          ],
          [
            paymentOptions.defaultValues.billingDetails.address.country,
            setUserAddressCountry
          ]
        ].forEach(val => {
          let value = val[0];
          if (value !== "") {
            return val[1](prev => {
              let newrecord = {...prev};
              newrecord.value = value;
              return newrecord;
            });
          }
        });
        if (paymentOptions.defaultValues.billingDetails.address.country === "") {
          let clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          let clientCountry = Utils$OrcaPaymentPage.getClientCountry(clientTimeZone);
          setUserAddressCountry(prev => {
            let newrecord = {...prev};
            newrecord.value = clientCountry.countryName;
            return newrecord;
          });
          return setCountry(param => clientCountry.countryName);
        }
        setUserAddressCountry(prev => {
          let newrecord = {...prev};
          newrecord.value = paymentOptions.defaultValues.billingDetails.address.country;
          return newrecord;
        });
        return setCountry(param => paymentOptions.defaultValues.billingDetails.address.country);
    }
    setOptions(param => ElementType$OrcaPaymentPage.itemToObjMapper(optionsDict, logger));
    let subscriptionEvents = SubscriptionEventTypes$OrcaPaymentPage.getSubscriptionEvents(optionsDict, "subscriptionEvents");
    setOptionsPayment(prev => {
      let newrecord = {...prev};
      newrecord.subscriptionEvents = subscriptionEvents;
      return newrecord;
    });
  };
  let setConfigs = async (dict, themeValues) => {
    try {
      let paymentOptions = Utils$OrcaPaymentPage.getDictFromObj(dict, "paymentOptions");
      let optionsDict = Utils$OrcaPaymentPage.getDictFromObj(dict, "options");
      let $$default = themeValues.default;
      let defaultRules = themeValues.defaultRules;
      let config = CardTheme$OrcaPaymentPage.itemToObjMapper(paymentOptions, $$default, defaultRules, logger);
      let optionsLocaleString = Utils$OrcaPaymentPage.getWarningString(optionsDict, "locale", "", logger);
      let optionsAppearance = CardTheme$OrcaPaymentPage.getAppearance("appearance", optionsDict, $$default, defaultRules, logger);
      let appearance = Primitive_object.equal(optionsAppearance, CardTheme$OrcaPaymentPage.defaultAppearance) ? config.appearance : optionsAppearance;
      let requestedLocale = optionsLocaleString === "" ? config.locale : optionsLocaleString;
      let resolvedLocale = requestedLocale === "auto" ? window.navigator.language : requestedLocale;
      let localeString = await CardTheme$OrcaPaymentPage.getLocaleObject(requestedLocale);
      let constantString = await CardTheme$OrcaPaymentPage.getConstantStringsObject();
      await S3Utils$OrcaPaymentPage.initializeCountryData(resolvedLocale, logger);
      setConfig(param => ({
        config: {
          appearance: appearance,
          locale: resolvedLocale,
          pmSessionId: config.pmSessionId,
          clientSecret: config.clientSecret,
          fonts: config.fonts,
          loader: config.loader,
          sdkAuthorization: config.sdkAuthorization
        },
        themeObj: appearance.variables,
        localeString: localeString,
        constantString: constantString,
        showLoader: config.loader === "Auto" || config.loader === "Always"
      }));
    } catch (exn) {
      
    }
    return setIsConfigReady(param => true);
  };
  let updateRedirectionFlags = UtilityHooks$OrcaPaymentPage.useUpdateRedirectionFlags();
  React.useEffect(() => {
    messageParentWindow([[
        "iframeMounted",
        true
      ]]);
    messageParentWindow([
      [
        "applePayMounted",
        true
      ],
      [
        "componentName",
        componentName
      ]
    ]);
    logger.setLogInitiated();
    let updatedState;
    updatedState = typeof paymentMethodList !== "object" && paymentMethodList === "Loading" ? (
        Utils$OrcaPaymentPage.checkPriorityList(paymentMethodOrder) ? "SemiLoaded" : "Loading"
      ) : paymentMethodList;
    let finalLoadLatency = launchTime <= 0.0 ? 0.0 : Date.now() - launchTime;
    if (typeof updatedState !== "object") {
      if (updatedState === "Loading") {
        logger.setLogInfo("Loading", "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
      } else {
        setPaymentMethodList(param => updatedState);
        logger.setLogInfo("SemiLoaded", "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
      }
    } else if (updatedState.TAG === "Loaded") {
      logger.setLogInfo("Loaded", "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
    } else {
      logger.setLogError("LoadError: " + JSON.stringify(updatedState._0), "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
    }
    window.addEventListener("click", ev => Utils$OrcaPaymentPage.handleOnClickPostMessage(keys.parentURL, ev));
    return () => {
      window.removeEventListener("click", ev => Utils$OrcaPaymentPage.handleOnClickPostMessage(keys.parentURL, ev));
    };
  }, []);
  React.useEffect(() => {
    CardUtils$OrcaPaymentPage.generateFontsLink(config.fonts);
    let dict = Utils$OrcaPaymentPage.getDictFromJson(config.appearance.rules);
    if (Object.entries(dict).length > 0) {
      Utils$OrcaPaymentPage.generateStyleSheet("", dict, "themestyle");
    }
    let match = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
    if (match !== "Payment") {
      let styleClass = [
        [
          "input-base",
          Utils$OrcaPaymentPage.getDictFromJson(options.style.base)
        ],
        [
          "input-complete",
          Utils$OrcaPaymentPage.getDictFromJson(options.style.complete)
        ],
        [
          "input-invalid",
          Utils$OrcaPaymentPage.getDictFromJson(options.style.invalid)
        ],
        [
          "input-empty",
          Utils$OrcaPaymentPage.getDictFromJson(options.style.empty)
        ]
      ];
      styleClass.map(item => {
        let dict = item[1];
        if (Object.entries(dict).length > 0) {
          Utils$OrcaPaymentPage.generateStyleSheet(item[0], dict, "widgetstyle");
          return;
        }
      });
    }
  }, [config]);
  React.useEffect(() => {
    let handleFun = ev => {
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      try {
        let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
        if (Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentElementCreate")) {
          if (Utils$OrcaPaymentPage.getDictIsSome(dict, "iframeId")) {
            setKeys(prev => {
              let newrecord = {...prev};
              newrecord.iframeId = Utils$OrcaPaymentPage.getString(dict, "iframeId", "no-element");
              return newrecord;
            });
          }
          if (Core__Option.getOr(Core__Option.flatMap(dict["paymentElementCreate"], Core__JSON.Decode.bool), false)) {
            if (Core__Option.getOr(Core__Option.flatMap(dict["otherElements"], Core__JSON.Decode.bool), false)) {
              updateOptions(dict);
            } else {
              let sdkSessionId = Utils$OrcaPaymentPage.getString(dict, "sdkSessionId", "no-element");
              logger.setSessionId(sdkSessionId);
              if (Core__Option.isSome(dict["loggerSource"])) {
                logger.setSource(Utils$OrcaPaymentPage.getString(dict, "loggerSource", "hyper_payment"));
              }
              if (isIntegrationEnv) {
                setBlockConfirm(param => Utils$OrcaPaymentPage.getBool(dict, "blockConfirm", false));
              }
              setCustomPodUri(param => Utils$OrcaPaymentPage.getString(dict, "customPodUri", ""));
              setSessionId(param => sdkSessionId);
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "publishableKey")) {
                logger.setMerchantId(Utils$OrcaPaymentPage.getString(dict, "publishableKey", ""));
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "analyticsMetadata")) {
                logger.setMetadata(Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "analyticsMetadata"));
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "onCompleteDoThisUsed")) {
                let isCallbackUsedVal = Utils$OrcaPaymentPage.getBool(dict, "onCompleteDoThisUsed", false);
                setIsCompleteCallbackUsed(param => isCallbackUsedVal);
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "isPaymentButtonHandlerProvided")) {
                let isSDKClick = Utils$OrcaPaymentPage.getBool(dict, "isPaymentButtonHandlerProvided", false);
                setIsPaymentButtonHandlerProvided(param => isSDKClick);
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentOptions")) {
                let paymentOptions = Utils$OrcaPaymentPage.getDictFromObj(dict, "paymentOptions");
                let clientSecret = Utils$OrcaPaymentPage.getWarningString(paymentOptions, "clientSecret", "", logger);
                let pmSessionId = Utils$OrcaPaymentPage.getWarningString(paymentOptions, "pmSessionId", "", logger);
                let sdkAuthorization = Utils$OrcaPaymentPage.getString(paymentOptions, "sdkAuthorization", "");
                setKeys(prev => {
                  let newrecord = {...prev};
                  newrecord.pmSessionId = pmSessionId;
                  newrecord.sdkAuthorization = sdkAuthorization;
                  newrecord.clientSecret = clientSecret;
                  return newrecord;
                });
                logger.setClientSecret(clientSecret);
                logger.setSdkAuthorization(sdkAuthorization);
                updateRedirectionFlags(paymentOptions);
                let promise = Utils$OrcaPaymentPage.getThemePromise(paymentOptions);
                if (promise !== undefined) {
                  Core__Promise.$$catch(promise.then(res => setConfigs(dict, res)), param => setConfigs(dict, {
                    default: DefaultTheme$OrcaPaymentPage.default,
                    defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
                  }));
                } else {
                  setConfigs(dict, {
                    default: DefaultTheme$OrcaPaymentPage.default,
                    defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
                  });
                }
              }
              let newLaunchTime = Utils$OrcaPaymentPage.getFloat(dict, "launchTime", 0.0);
              setLaunchTime(param => newLaunchTime);
              let initLoadlatency = Date.now() - newLaunchTime;
              logger.setLogInfo(Window$OrcaPaymentPage.hrefWithoutSearch, "APP_RENDERED", undefined, initLoadlatency, undefined, undefined, undefined);
              [
                [
                  "iframeId",
                  "no-element"
                ],
                [
                  "publishableKey",
                  ""
                ],
                [
                  "paymentId",
                  ""
                ],
                [
                  "parentURL",
                  "*"
                ],
                [
                  "sdkHandleOneClickConfirmPayment",
                  true
                ]
              ].forEach(keyPair => CommonHooks$OrcaPaymentPage.updateKeys(dict, keyPair, setKeys));
              let renderLatency = Date.now() - initTimestamp;
              logger.setLogInfo("", "PAYMENT_OPTIONS_PROVIDED", undefined, renderLatency, undefined, undefined, undefined);
              updateOptions(dict);
            }
          } else if (Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentOptions")) {
            let paymentOptions$1 = Utils$OrcaPaymentPage.getDictFromObj(dict, "paymentOptions");
            let clientSecret$1 = Utils$OrcaPaymentPage.getWarningString(paymentOptions$1, "clientSecret", "", logger);
            let pmSessionId$1 = Utils$OrcaPaymentPage.getWarningString(paymentOptions$1, "pmSessionId", "", logger);
            let sdkAuthorization$1 = Utils$OrcaPaymentPage.getString(paymentOptions$1, "sdkAuthorization", "");
            setKeys(prev => {
              let newrecord = {...prev};
              newrecord.pmSessionId = pmSessionId$1;
              newrecord.sdkAuthorization = sdkAuthorization$1;
              newrecord.clientSecret = clientSecret$1;
              return newrecord;
            });
            logger.setClientSecret(clientSecret$1);
            logger.setSdkAuthorization(sdkAuthorization$1);
            updateRedirectionFlags(paymentOptions$1);
            let promise$1 = Utils$OrcaPaymentPage.getThemePromise(paymentOptions$1);
            if (promise$1 !== undefined) {
              Core__Promise.$$catch(promise$1.then(res => setConfigs(dict, res)), param => setConfigs(dict, {
                default: DefaultTheme$OrcaPaymentPage.default,
                defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
              }));
            } else {
              setConfigs(dict, {
                default: DefaultTheme$OrcaPaymentPage.default,
                defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
              });
            }
          }
        } else if (Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentElementsUpdate")) {
          updateOptions(dict);
        } else if (Utils$OrcaPaymentPage.getDictIsSome(dict, "ElementsUpdate")) {
          logger.setLogInfo("SDK Credentials Received from Loader", "UPDATE_SDK", undefined, undefined, undefined, undefined, undefined);
          let optionsDict = Utils$OrcaPaymentPage.getDictFromObj(dict, "options");
          let clientSecret$2 = dict["clientSecret"];
          if (clientSecret$2 !== undefined) {
            setKeys(prev => {
              let newrecord = {...prev};
              newrecord.clientSecret = Utils$OrcaPaymentPage.getStringFromJson(clientSecret$2, "");
              return newrecord;
            });
            setConfig(prev => {
              let init = prev.config;
              return {
                config: {
                  appearance: init.appearance,
                  locale: init.locale,
                  pmSessionId: init.pmSessionId,
                  clientSecret: Utils$OrcaPaymentPage.getStringFromJson(clientSecret$2, ""),
                  fonts: init.fonts,
                  loader: init.loader,
                  sdkAuthorization: init.sdkAuthorization
                },
                themeObj: prev.themeObj,
                localeString: prev.localeString,
                constantString: prev.constantString,
                showLoader: prev.showLoader
              };
            });
          }
          let sdkAuthorization$2 = dict["sdkAuthorization"];
          if (sdkAuthorization$2 !== undefined) {
            setKeys(prev => {
              let newrecord = {...prev};
              newrecord.sdkAuthorization = Utils$OrcaPaymentPage.getStringFromJson(sdkAuthorization$2, "");
              return newrecord;
            });
            setConfig(prev => {
              let init = prev.config;
              return {
                config: {
                  appearance: init.appearance,
                  locale: init.locale,
                  pmSessionId: init.pmSessionId,
                  clientSecret: init.clientSecret,
                  fonts: init.fonts,
                  loader: init.loader,
                  sdkAuthorization: Utils$OrcaPaymentPage.getStringFromJson(sdkAuthorization$2, "")
                },
                themeObj: prev.themeObj,
                localeString: prev.localeString,
                constantString: prev.constantString,
                showLoader: prev.showLoader
              };
            });
          }
          if (Object.keys(optionsDict).length > 0) {
            let promise$2 = Utils$OrcaPaymentPage.getThemePromise(optionsDict);
            if (promise$2 !== undefined) {
              Core__Promise.$$catch(promise$2.then(res => setConfigs(dict, res)), param => setConfigs(dict, {
                default: DefaultTheme$OrcaPaymentPage.default,
                defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
              }));
            } else {
              setConfigs(dict, {
                default: DefaultTheme$OrcaPaymentPage.default,
                defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
              });
            }
          }
        }
        if (Core__Option.isSome(dict["isTestMode"])) {
          let isTestMode = Utils$OrcaPaymentPage.getBool(dict, "isTestMode", false);
          setIsTestMode(param => isTestMode);
        }
        if (Core__Option.isSome(dict["isSavedCardCvcFlow"])) {
          setIsSavedCardCvcFlow(param => Utils$OrcaPaymentPage.getBool(dict, "isSavedCardCvcFlow", false));
          let endpoint = Utils$OrcaPaymentPage.getString(dict, "endpoint", "");
          if (endpoint !== "") {
            ApiEndpoint$OrcaPaymentPage.setApiEndPoint(endpoint);
          }
        }
        if (Core__Option.isSome(dict["cardCollectionMode"])) {
          setCardCollectionMode(param => {
            let match = Utils$OrcaPaymentPage.getString(dict, "cardCollectionMode", "tokenise");
            if (match === "raw") {
              return "RawEmit";
            } else {
              return "Tokenise";
            }
          });
        }
        if (Core__Option.isSome(dict["savedCardBrand"])) {
          let savedCardBrand = CardUtils$OrcaPaymentPage.normalizeCardBrand(Utils$OrcaPaymentPage.getString(dict, "savedCardBrand", ""));
          setCardBrand(param => savedCardBrand);
          setSavedCardBrand(param => savedCardBrand);
        }
        if (Core__Option.isSome(dict["supportedCardBrands"])) {
          setSupportedCardBrands(param => Utils$OrcaPaymentPage.getStrArray(dict, "supportedCardBrands"));
        }
        if (Core__Option.isSome(dict["isBancontactCardFlow"])) {
          setIsBancontactCardFlow(param => Utils$OrcaPaymentPage.getBool(dict, "isBancontactCardFlow", false));
        }
        if (Core__Option.isSome(dict["cardFlowType"])) {
          setCardFlowType(param => CardThemeType$OrcaPaymentPage.getPaymentMode(Utils$OrcaPaymentPage.getString(dict, "cardFlowType", "payment")));
        }
        if (Utils$OrcaPaymentPage.getDictIsSome(dict, "sessions")) {
          setSessions(param => ({
            TAG: "Loaded",
            _0: Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "sessions")
          }));
        }
        if (Utils$OrcaPaymentPage.getDictIsSome(dict, "sessionUpdate")) {
          setUpdateSession(param => Core__Option.getOr(Core__JSON.Decode.bool(Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "sessionUpdate")), false));
        }
        if (Utils$OrcaPaymentPage.getDictIsSome(dict, "isReadyToPay")) {
          setIsGooglePayReady(param => Core__Option.getOr(Core__JSON.Decode.bool(Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "isReadyToPay")), false));
        }
        if (Utils$OrcaPaymentPage.getDictIsSome(dict, "trustPayScriptStatus")) {
          setTrustPayScriptStatus(param => {
            let match = Utils$OrcaPaymentPage.getString(dict, "trustPayScriptStatus", "");
            switch (match) {
              case "failed" :
                return "Failed";
              case "loaded" :
                return "Loaded";
              case "loading" :
                return "Loading";
              default:
                return "NotLoaded";
            }
          });
        }
        if (Utils$OrcaPaymentPage.getDictIsSome(dict, "isSamsungPayReady")) {
          setIsSamsungPayReady(param => Utils$OrcaPaymentPage.getBool(dict, "isSamsungPayReady", false));
        }
        if (Utils$OrcaPaymentPage.getDictIsSome(dict, "customBackendUrl") && Utils$OrcaPaymentPage.getString(dict, "customBackendUrl", "").length > 0 && Utils$OrcaPaymentPage.getDictIsSome(dict, "endpoint")) {
          let endpoint$1 = Utils$OrcaPaymentPage.getString(dict, "endpoint", "");
          if (endpoint$1 !== "") {
            ApiEndpoint$OrcaPaymentPage.setApiEndPoint(endpoint$1);
          }
        }
        if (Utils$OrcaPaymentPage.getDictIsSome(dict, "clientList")) {
          let clientListJson = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "clientList");
          let listDict = Utils$OrcaPaymentPage.getDictFromJson(clientListJson);
          if (optionsPayment.business.name === "") {
            setOptionsPayment(prev => {
              let newrecord = {...prev};
              newrecord.business = {
                name: Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromDict(listDict, "intent_data"), "merchant_name", "")
              };
              return newrecord;
            });
          }
          let finalLoadLatency = launchTime <= 0.0 ? 0.0 : Date.now() - launchTime;
          let isClientListError = Primitive_object.equal(clientListJson, {}) || Core__Option.isSome(listDict["error"]);
          let updatedState;
          if (isClientListError) {
            updatedState = {
              TAG: "LoadError",
              _0: clientListJson
            };
          } else {
            let isNonEmptyPaymentMethodList = Utils$OrcaPaymentPage.getArray(listDict, "payment_methods_enabled").length > 0;
            updatedState = isNonEmptyPaymentMethodList ? ({
                TAG: "Loaded",
                _0: clientListJson
              }) : ({
                TAG: "LoadError",
                _0: clientListJson
              });
          }
          let evalMethodsList = () => {
            if (typeof updatedState !== "object") {
              return;
            } else if (updatedState.TAG === "Loaded") {
              return logger.setLogInfo("Loaded", "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
            } else {
              return logger.setLogError("LoadError: " + JSON.stringify(updatedState._0), "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
            }
          };
          setPaymentMethodList(param => updatedState);
          let customerPaymentMethods = PaymentType$OrcaPaymentPage.createCustomerObjArrFromClientList(dict, "clientList");
          setOptionsPayment(prev => {
            let newrecord = {...prev};
            newrecord.customerPaymentMethods = customerPaymentMethods;
            return newrecord;
          });
          if (optionsPayment.displaySavedPaymentMethods) {
            if (typeof customerPaymentMethods === "object") {
              if (customerPaymentMethods.TAG === "LoadedSavedCards" && customerPaymentMethods._0.length > 0) {
                logger.setLogInfo("Loaded", "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
              } else {
                evalMethodsList();
              }
            }
          } else {
            evalMethodsList();
          }
        }
        if (Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentManagementMethods")) {
          let paymentManagementMethods = UnifiedHelpersV2$OrcaPaymentPage.createPaymentsObjArr(dict, "paymentManagementMethods");
          setPaymentManagementList(param => paymentManagementMethods);
        }
        if (Utils$OrcaPaymentPage.getDictIsSome(dict, "sdkConfigs")) {
          let sdkConfigsJson = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "sdkConfigs");
          let sdkConfigsDict = Utils$OrcaPaymentPage.getDictFromJson(sdkConfigsJson);
          let isSdkConfigsError = sdkConfigsJson === null || Primitive_object.equal(sdkConfigsJson, {}) || Core__Option.isSome(sdkConfigsDict["error"]);
          let updatedState$1 = isSdkConfigsError ? ({
              TAG: "LoadError",
              _0: sdkConfigsJson
            }) : ({
              TAG: "Loaded",
              _0: sdkConfigsJson
            });
          let finalLoadLatency$1 = launchTime <= 0.0 ? 0.0 : Date.now() - launchTime;
          if (typeof updatedState$1 !== "object") {
            updatedState$1 === "Loading";
          } else if (updatedState$1.TAG === "Loaded") {
            logger.setLogInfo("Loaded", "SDK_CONFIGS_CALL", undefined, finalLoadLatency$1, undefined, undefined, undefined);
          } else {
            logger.setLogError("LoadError: " + JSON.stringify(updatedState$1._0), "SDK_CONFIGS_CALL", undefined, finalLoadLatency$1, undefined, undefined, undefined);
          }
          setSdkConfigs(param => updatedState$1);
          if (!isSdkConfigsError) {
            setSdkConfigsValue(param => SdkConfigParser$OrcaPaymentPage.itemToObjMapper(sdkConfigsJson));
          }
        }
        if (Core__Option.isSome(dict["applePayCanMakePayments"])) {
          setIsApplePayReady(param => true);
        }
        if (Core__Option.isSome(dict["applePaySessionObjNotPresent"])) {
          setIsApplePayReady(prev => false);
        }
        if (!Core__Option.isSome(dict["updateIntentLoading"])) {
          return;
        }
        let isLoading = Utils$OrcaPaymentPage.getBool(dict, "updateIntentLoading", false);
        setIsUpdateIntentLoading(param => isLoading);
        if (isLoading) {
          return logger.setLogInfo("Update Intent Loading Started", "UPDATE_INTENT", undefined, undefined, undefined, undefined, undefined);
        } else {
          return logger.setLogInfo("Update Intent Loading Completed", "UPDATE_INTENT", undefined, undefined, undefined, undefined, undefined);
        }
      } catch (exn) {
        return setIntegrateErrorError(param => true);
      }
    };
    return Utils$OrcaPaymentPage.handleMessage(handleFun, "Error in parsing sent Data");
  }, [
    paymentMethodOrder,
    optionsPayment
  ]);
  let observer = new ResizeObserver(entries => {
    entries.map(item => setDivH(param => item.contentRect.height));
  });
  let r = divRef.current;
  if (!(r == null)) {
    observer.observe(r);
  }
  React.useEffect(() => {
    let iframeHeight = divH === 0.0 ? divH : divH + 1.0;
    messageParentWindow([
      [
        "iframeHeight",
        iframeHeight
      ],
      [
        "iframeId",
        iframeId
      ]
    ]);
  }, [
    divH,
    iframeId
  ]);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(UpdateIntentOverlay$OrcaPaymentPage.make, {}),
      props.children
    ],
    ref: Primitive_option.some(divRef),
    className: "relative"
  });
}

let make = LoaderController;

export {
  make,
}
/* jotai Not a pure module */
